import React, { useEffect, useState } from "react";
import { getTherapists } from "../../utils/apiUtils.js";
import TherapistList from "../../components/TherapistList/TherapistList.js";

function TherapistPage() {
  const [allTherapists, setAllTherapists] = useState([]);

  const fetchTherapists = async () => {
    try {
      const { data } = await getTherapists();
      setAllTherapists(data);
    } catch (error) {
      console.error("Error fetching terapists:", error);
    }
  };
  console.log(allTherapists);
  useEffect(() => {
    fetchTherapists();
  }, []);

  return (
    <div>
      <TherapistList
        allTherapists={allTherapists}
        setAllTherapists={setAllTherapists}
      />
    </div>
  );
}

export default TherapistPage;
